import React from 'react';
import { connect } from 'react-redux';
import BlitzDefaultContent from './BlitzDefault.content';
import BlitzDefaultContentCustom from './BlitzDefaultCustom.content';
import StealthDR01 from './Stealth-DR-01';
import MotoTruck from './MotoTruckTemplate';
import DeliveryPickingTemplate from './DeliveryPickingTemplate';
import { getSubSetting } from '../../../Utils/Common';

function DeliveryCustomTemplate({
    delivery: { si_data, dr_picking },
    auth,
    componentRef,
}) {
    const subs_setting = getSubSetting();
    let template_label;
    if (dr_picking) {
        template_label = 'dr_picking';
    } else {
        template_label = si_data.template_setting
            ? si_data.template_setting.template_label
            : 'none';
    }

    return (
        <>
            {(() => {
                switch (template_label) {
                    case 'blitz_default':
                        return (
                            <>
                                <BlitzDefaultContent
                                    si_data={si_data}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                    subs_setting={subs_setting}
                                />
                                <div style={{ display: 'none' }}>
                                    <BlitzDefaultContent
                                        si_data={si_data}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                        subs_setting={subs_setting}
                                    />
                                </div>
                            </>
                        );
                    case 'blitz_default_custom':
                        return (
                            <>
                                <BlitzDefaultContentCustom
                                    si_data={si_data}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                    subs_setting={subs_setting}
                                />
                                <div style={{ display: 'none' }}>
                                    <BlitzDefaultContentCustom
                                        si_data={si_data}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                        subs_setting={subs_setting}
                                    />
                                </div>
                            </>
                        );
                    case 'stealth_dr_01':
                        return (
                            <>
                                <StealthDR01
                                    si_data={si_data}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                    subs_setting={subs_setting}
                                />
                                <div style={{ display: 'none' }}>
                                    <StealthDR01
                                        si_data={si_data}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                        subs_setting={subs_setting}
                                    />
                                </div>
                            </>
                        );
                    case 'mototruck':
                        return (
                            <>
                                <MotoTruck
                                    si_data={si_data}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                    subs_setting={subs_setting}
                                />
                                <div style={{ display: 'none' }}>
                                    <MotoTruck
                                        si_data={si_data}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                        subs_setting={subs_setting}
                                    />
                                </div>
                            </>
                        );
                    case 'dr_picking':
                        return (
                            <>
                                <DeliveryPickingTemplate
                                    si_data={si_data}
                                    auth={auth}
                                    print="0"
                                    print_rows="5"
                                    subs_setting={subs_setting}
                                />
                                <div style={{ display: 'none' }}>
                                    <DeliveryPickingTemplate
                                        si_data={si_data}
                                        auth={auth}
                                        ref={componentRef}
                                        print="1"
                                        print_rows="19"
                                        subs_setting={subs_setting}
                                    />
                                </div>
                            </>
                        );
                    default:
                        return (
                            <>
                                <h4>-- There's No Data To Show--</h4>
                            </>
                        );
                    // return (
                    //   <>
                    //     <StealthDR01
                    //       si_data={si_data}
                    //       auth={auth}
                    //       print='0'
                    //       print_rows='5'
                    //     />
                    //     <div style={{ display: "none" }}>
                    //       <StealthDR01
                    //         si_data={si_data}
                    //         auth={auth}
                    //         ref={componentRef}
                    //         print='1'
                    //         print_rows='19'
                    //       />
                    //     </div>
                    //   </>
                    // );
                }
            })()}
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    delivery: state.delivery,
});

export default connect(mapStateToProps, {})(DeliveryCustomTemplate);
